import React from "react";
import ShareIcon from "@mui/icons-material/Share";
import { toast } from "react-toastify";
import "./sharebutton.css";

const ShareButton = ({ productUrl }) => {
  const shareProduct = async () => {
    const shareData = {
      title: "Check out this product!",
      text: "I found this amazing product for you. Take a look:",
      url: productUrl,
    };

    // Check if Web Share API is supported
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        toast.success("Product link shared successfully!", {
          position: "top-right",
        });
      } catch (error) {
        toast.error("Failed to share. Try again.", {
          position: "top-right",
        });
      }
    } else {
      // Fallback for browsers without Web Share API
      navigator.clipboard.writeText(productUrl).then(() => {
        toast.success("Link copied to clipboard!", {
          position: "top-right",
        });
      }).catch(() => {
        toast.error("Failed to copy link. Please try again.", {
          position: "top-right",
        });
      });
    }
  };

  return (
    <button className="share-button" onClick={shareProduct}>
      <ShareIcon className="share-icon" /> Share
    </button>
  );
};

export default ShareButton;
